<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <h3 class="title is-size-2 has-text-grey">404 not found</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'errorPage',
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/errorPage.vue